export const SET_MUTUAL_ACTION_PLAN = 'SET_MUTUAL_ACTION_PLAN'

export const setMutualActionPlan = (MutualActionPlan) => {
	return {
		type: 'SET_MUTUAL_ACTION_PLAN',
		MutualActionPlan
	}
}